define('app/models/sale',['app/setup'], function(takhfifan) {

  takhfifan.Sale = Backbone.Model.extend({
    defaults: {
      sold: 0,
      available: 0
    },
    urlRoot: '/ajax/product/elements/i',

    parse: function(resp, xhr) {

      var price = parseInt(resp.price, 10) / 10,
          rp = parseInt(resp.retailPrice,10) / 10,
          discount = Math.round((1 - (price / rp)) * 100);

      this.set({
        'sold': parseInt(resp.sold),
        'available': parseInt(resp.available),
        'expired': resp.expired,
        'isSoldOut': resp.isSoldOut,
        'allowedProductsPrices': resp.allowedProductsPrices,
        'seconds' : resp.seconds,
        'partnerUrl' : resp.partnerUrl,
        'dealCondition' : resp.dealCondition,
        'price' : price,
        'retailPrice' : rp,
        'discount' : discount
      });

      takhfifan.eventHub.trigger('dealseconds:' + this.get('id'), parseInt(resp.seconds));
      takhfifan.eventHub.trigger('cartinfo:' + this.get('id'), this);

      if (this.get('expired') || this.get('isSoldOut')) {
        takhfifan.eventHub.trigger('groupedProduct:removeAssociate', {
          productId: this.get('id')
        });
      }
      if (this.get('isSoldOut')) {
        takhfifan.eventHub.trigger('buyButton:soldOut', this);
      }
      if (this.get('allowedProductsPrices')) {
        _tkhProductPrices = this.get('allowedProductsPrices');
        if(_.isEmpty(_tkhProductPrices)){
          takhfifan.eventHub.trigger('buyButton:soldOut', this);
        }else{
          var availableItems = 0;
          _.each(_tkhProductPrices, function(item, itemId){
            if(!item.isSoldOut && !item.isExpired){
              takhfifan.eventHub.trigger('configurableItemSetup:'+ itemId);
              availableItems++;
            }
          });
          if(availableItems === 0){
            takhfifan.eventHub.trigger('buyButton:soldOut', this);
          }
        }
      }
    }

  });
});

